'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Introduction = require('./Introduction.scss');

var _Introduction2 = _interopRequireDefault(_Introduction);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

var _WishlistButton = require('components/General/Buttons/WishlistButton');

var _WishlistButton2 = _interopRequireDefault(_WishlistButton);

var _RatingPoint = require('components/General/RatingPoint/RatingPoint');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

var _media = require('utils/media');

var _trip2 = require('utils/trip');

var _helpers = require('utils/helpers.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Introduction: {
    displayName: 'Introduction'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Introduction.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var ScrollLink = _reactScroll2.default.Link;

var Introduction = _wrapComponent('Introduction')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
    siteConfigs: state.info.siteConfigs,
    locale: state.language.locale
  };
}, { openShare: _trip.openShare, changeTab: _trip.changeTab }), _dec2 = (0, _reactCssModules2.default)(_Introduction2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Introduction, _Component);

  function Introduction(props) {
    (0, _classCallCheck3.default)(this, Introduction);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Introduction.__proto__ || (0, _getPrototypeOf2.default)(Introduction)).call(this, props));

    _this.openShare = _this.openShare.bind(_this);

    if (!(typeof _this.openShare === 'function')) {
      throw new TypeError('Value of "this.openShare" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openShare));
    }

    _this.changeToReview = _this.changeToReview.bind(_this);

    if (!(typeof _this.changeToReview === 'function')) {
      throw new TypeError('Value of "this.changeToReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.changeToReview));
    }

    return _this;
  }

  (0, _createClass3.default)(Introduction, [{
    key: 'openShare',
    value: function openShare() {
      this.props.openShare();
    }
  }, {
    key: 'changeToReview',
    value: function changeToReview() {
      var bannerH = 240;
      var priceH = 80;
      this.props.changeTab('review');
      window.scrollTo(0, bannerH - priceH);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          trip = _props.trip,
          isWishlisted = _props.isWishlisted,
          siteConfigs = _props.siteConfigs,
          locale = _props.locale,
          peerReview = _props.peerReview;

      var reviews = trip.reviews || [];
      var wo = trip.travelers_without_review || 0;
      var count = reviews.length + wo;
      var wishlisted = isWishlisted[trip._id] || { state: false, loading: false };
      var transportation = (0, _trip2.getTransportation)(trip.transportation);
      var defaultImage = require('theme/images/default-img.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'share-wishlist-container' },
          _react3.default.createElement(
            'a',
            { styleName: 'share-container', onClick: this.openShare },
            _react3.default.createElement('div', { styleName: 'share-button' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.share.button' })
            )
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_WishlistButton2.default, { label: true, active: wishlisted.state !== wishlisted.loading, tripSlug: trip.slug, tripId: trip._id })
          )
        ),
        ((0, _helpers.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip || trip.tmt_tag) && !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'tags' },
          (0, _helpers.isServiceTime)('06') && siteConfigs.instantEnabled && trip.is_instant_trip && _react3.default.createElement(
            'div',
            { styleName: 'tag-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'instant-tag-band' },
              _react3.default.createElement('i', { styleName: 'instant-tag-icon' }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.available_tomorrow' })
              )
            ),
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement('div', { styleName: 'instant-tag-arrow-top' }),
              _react3.default.createElement('div', { styleName: 'instant-tag-arrow-bottom' })
            )
          ),
          trip.tmt_tag && _react3.default.createElement(
            'div',
            { styleName: 'tag-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'tmt-tag-band' },
              _react3.default.createElement('i', { styleName: 'tmt-tag-icon' }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.trip_detail.exclusive' })
              )
            ),
            _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-top' }),
              _react3.default.createElement('div', { styleName: 'tmt-tag-arrow-bottom' })
            )
          )
        ),
        _react3.default.createElement(
          'h1',
          { styleName: (trip.tmt_tag || (0, _helpers.isServiceTime)()) && !peerReview ? 'trip-title-with-tag' : 'trip-title' },
          trip.name
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'trip-location' },
          trip.destination_location
        ),
        count > 0 && _react3.default.createElement(
          'div',
          null,
          _react3.default.createElement(
            ScrollLink,
            { to: 'review', smooth: true, offset: -80, duration: 500 },
            _react3.default.createElement(
              'div',
              { styleName: 'point-container' },
              trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating }),
              _react3.default.createElement(
                'span',
                null,
                '(',
                count,
                ')'
              )
            )
          )
        ),
        !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'extra-infos' },
          trip.tags && trip.tags.indexOf('tour_shared') < 0 && locale === 'en' && _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.private_n_personal' })
          ),
          locale === 'en' && _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.tip_included' })
          ),
          locale === 'th' && _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(
              'span',
              null,
              '\u0E21\u0E35\u0E25\u0E48\u0E32\u0E21\u0E04\u0E19\u0E44\u0E17\u0E22\u0E41\u0E1B\u0E25\u0E20\u0E32\u0E29\u0E32'
            )
          ),
          locale === 'th' && _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(
              'span',
              null,
              '\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E0A\u0E35\u0E27\u0E34\u0E15'
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.satisfaction_guaranteed' })
          ),
          trip.search_information && trip.search_information.is_hotel_pickup && _react3.default.createElement(
            'div',
            { styleName: 'extra-info' },
            _react3.default.createElement('i', null),
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.body.free_hotel_pickup' })
          )
        ),
        _react3.default.createElement('p', { dangerouslySetInnerHTML: { __html: trip && trip.introduction } }),
        !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'details-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'detail-item-row' },
            _react3.default.createElement(
              'div',
              { styleName: 'detail-item' },
              _react3.default.createElement('i', { styleName: trip.transportation === 'Public Transportation' ? 'public-transportation-icon' : 'private-car-icon' }),
              _react3.default.createElement(
                'p',
                { styleName: 'icon-caption' },
                transportation.standard ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: transportation.id }) : transportation.id
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'detail-item' },
              _react3.default.createElement('i', { styleName: 'duration-icon' }),
              _react3.default.createElement(
                'p',
                { styleName: 'icon-caption' },
                (0, _trip2.getHour)(trip.duration),
                ' ',
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.hour' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'detail-item' },
              _react3.default.createElement('i', { styleName: 'popular-icon' }),
              _react3.default.createElement(
                'p',
                { styleName: 'icon-caption' },
                _react3.default.createElement(
                  'span',
                  null,
                  (0, _helpers.commaizeInt)(trip.view_count)
                ),
                _react3.default.createElement('br', null),
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.popular' })
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'detail-item-row' },
            trip.activities.map(function (act, index) {
              return _react3.default.createElement(
                'div',
                { styleName: 'detail-item-activity', key: 'activity-' + index },
                _react3.default.createElement('i', { styleName: (0, _trip2.getActivityIcon)(act) }),
                _react3.default.createElement(
                  'p',
                  { styleName: 'icon-caption' },
                  act
                )
              );
            })
          )
        ),
        !siteConfigs.tripHideLx && !(trip.tags && trip.tags.indexOf('tour_shared') >= 0) && !peerReview && _react3.default.createElement(
          'div',
          { styleName: 'lx-profile' },
          _react3.default.createElement(
            _Link2.default,
            { to: '/local-expert/' + trip.user_id.slug },
            _react3.default.createElement(
              'div',
              { styleName: 'lx-profile-pic' },
              _react3.default.createElement('img', { src: trip.user_id && trip.user_id.avatar_image ? (0, _media.path)(trip.user_id.avatar_image, 'profileAvatar') : defaultImage, alt: trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last })
            )
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'p',
              { styleName: 'lx-lx' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.lx.hosted_by' })
            ),
            _react3.default.createElement(
              'h3',
              { styleName: 'lx-name' },
              _react3.default.createElement(
                _Link2.default,
                { to: '/local-expert/' + trip.user_id.slug },
                trip.user_id && trip.user_id.name && trip.user_id.name.first + ' ' + trip.user_id.name.last
              )
            )
          )
        )
      );
    }
  }]);
  return Introduction;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  isWishlisted: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  peerReview: _react2.PropTypes.bool,
  // isOneTab: PropTypes.bool,
  openShare: _react2.PropTypes.func,
  changeTab: _react2.PropTypes.func
  // isMobile: PropTypes.bool,
}, _temp)) || _class) || _class));

exports.default = Introduction;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Introduction.js
// module id = 1633
// module chunks = 0